import "./index.css";
import { loadRuntimeConfig } from "./runtimeConfig";
import { listenForParentToken } from "./auth/parentTokenBridge";

// Before anything async: Sales Central may post its auth token as soon as the
// iframe loads, long before config.json and MSAL are ready. See
// auth/parentTokenBridge.js.
listenForParentToken();

// Configuration must be in place before anything else is evaluated: authConfig.js
// builds msalConfig at module scope, and Authorization.js picks its SSO / mock
// implementation at module scope too. The dynamic import below defers that whole
// module graph until after config.json has resolved.
loadRuntimeConfig()
	.then(() => import("./bootstrap"))
	.catch((error) => {
		console.error("Failed to load configuration:", error);
		document.getElementById("root").innerHTML =
			"<div style=\"font-family:system-ui,sans-serif;max-width:32rem;margin:20vh auto;padding:0 1.5rem;text-align:center\">" +
			"<h1 style=\"font-size:1.25rem;margin:0 0 .5rem\">Configuration Error</h1>" +
			"<p style=\"margin:0;color:#555\">Unable to load application configuration. Please try again, or contact support if this keeps happening.</p>" +
			"</div>";
	});
